import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row col-xs-12 items-center" }
const _hoisted_2 = { class: "row justify-start items-center col-xs-11" }
const _hoisted_3 = { class: "col-xs-12 col-md-4 wrap-anyway" }
const _hoisted_4 = { class: "row col-xs-12 col-md-8 no-wrap" }
const _hoisted_5 = { class: "col-xs-1 text-center" }
const _hoisted_6 = {
  key: 0,
  class: "column justify-start items-start col-xs-12 q-mt-sm"
}
const _hoisted_7 = { class: "row col-xs-12 justify-start" }

import difference from 'lodash/difference';
import { computed, toValue, watch } from 'vue';

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import useValidation from 'SharedDir/common/composables/useValidation';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { HandsontableCellType, HandsontableCellTypes } from 'SharedDir/constants/field-types';
import { Catalogs } from 'SharedDir/declarations/catalogs';
import { LabeledTableColumnType } from 'SharedDir/declarations/fields';

import TableColumn from './table-column';

export interface Props extends PropValue<null | TableColumn> {
  readonly?: boolean;
  allColumns: Array<LabeledTableColumnType>;
  columnTypes: { value: HandsontableCellType; label: string }[];
  catalogs: Catalogs.Catalogs[];
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'TableColumnItem',
},
  __name: 'TableColumn',
  props: {
    readonly: { type: Boolean, default: false },
    allColumns: {},
    columnTypes: {},
    catalogs: {},
    modelValue: {}
  },
  emits: ["update:modelValue", "remove"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits, {
  transform: (v) => v ?? new TableColumn(),
});

const proxyInput = () => {
  if (!innerValue.value.isSummary) {
    innerValue.value.summedColumns = [];
  }
  emitValue();
};

watch(
  () => props.allColumns,
  (newValue: Array<TableColumn>) => {
    const summeryColumns = newValue.filter(({ isSummary }) => isSummary).map(({ slug }) => slug);
    const diff = difference(innerValue.value.summedColumns, summeryColumns);
    if (innerValue.value.summedColumns && innerValue.value.summedColumns.length > diff.length) {
      innerValue.value.summedColumns = diff;
      proxyInput();
    }
  }
);

watch(
  () => props.columnTypes,
  () => {
    const availableTypes = props.columnTypes.map(({ value }) => value);
    if (!availableTypes.includes(innerValue.value.type)) {
      /**
       * Если тип колонки не поддерживается, то принудительно меняем его на текстовый
       * и сбрасываем все связанные с ним параметры
       */
      innerValue.value.type = HandsontableCellType.text;
      innerValue.value.isSummary = false;
      innerValue.value.summedColumns = [];
      emitValue();
    }
  }
);

const availableForSumColumns = computed(() => {
  return props.allColumns
    .filter(
      ({ slug, type }) => innerValue.value.slug !== slug && type === HandsontableCellType.numeric
    )
    .map((column) => ({ value: column.slug, label: column.label, disable: column.isSummary }));
});

const availableToBeSummed = computed(() => {
  return (
    innerValue.value.type === HandsontableCellType.numeric &&
    availableForSumColumns.value.filter(({ disable }) => !disable).length > 0
  );
});
const { NotEmpty } = useValidation();

const availableCatalogColumns = computed(() =>
  props.allColumns
    .filter(({ type }) => type === HandsontableCellType.catalog)
    .map(({ slug }) => slug)
);

return (_ctx: any,_cache: any) => {
  const _component_s_input = _resolveComponent("s-input")!
  const _component_s_select = _resolveComponent("s-select")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_q_option_group = _resolveComponent("q-option-group")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_s_input, {
          modelValue: _unref(innerValue).slug,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(innerValue).slug) = $event)),
          class: "s-form-input required",
          clearable: "",
          outlined: "",
          dense: "",
          required: "",
          "hide-bottom-space": "",
          label: "Служебное наименование (slug)",
          readonly: _ctx.readonly,
          autocomplete: "table-column-slug`",
          rules: [_unref(NotEmpty)('Slug обязателен для заполнения')],
          onBlur: proxyInput
        }, null, 8, ["modelValue", "readonly", "rules"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_s_select, {
          modelValue: _unref(innerValue).type,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).type) = $event)),
            _cache[2] || (_cache[2] = ($event: any) => (proxyInput() || (_unref(innerValue).catalogSlug = null)))
          ],
          class: "s-form-select required base-margin-left",
          label: "Тип",
          outlined: "",
          dense: "",
          readonly: _ctx.readonly,
          "emit-value": "",
          "map-options": "",
          "options-dense": "",
          options: _ctx.columnTypes
        }, null, 8, ["modelValue", "readonly", "options"]),
        (_unref(innerValue).type === _unref(HandsontableCellType).catalog)
          ? (_openBlock(), _createBlock(_component_s_select, {
              key: 0,
              modelValue: _unref(innerValue).catalogSlug,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_unref(innerValue).catalogSlug) = $event)),
                proxyInput
              ],
              class: "s-form-select required base-margin-left",
              label: "Название каталога",
              outlined: "",
              dense: "",
              readonly: _ctx.readonly,
              "emit-value": "",
              "map-options": "",
              "option-value": "slug",
              "option-label": "name",
              "options-dense": "",
              filtering: "",
              options: _ctx.catalogs
            }, null, 8, ["modelValue", "readonly", "options"]))
          : (_unref(innerValue).type === _unref(HandsontableCellType).catalogRecordAmount)
            ? (_openBlock(), _createBlock(_component_s_select, {
                key: 1,
                modelValue: _unref(innerValue).catalogColumnSlug,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_unref(innerValue).catalogColumnSlug) = $event)),
                  proxyInput
                ],
                class: "s-form-select required base-margin-left",
                label: "Slug связанного столбца",
                outlined: "",
                required: "",
                dense: "",
                readonly: _ctx.readonly,
                "options-dense": "",
                filtering: "",
                options: availableCatalogColumns.value
              }, {
                prepend: _withCtx(() => [
                  _createVNode(SIcon, {
                    size: "small",
                    name: "help",
                    color: "brand"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode(" Укажите пожалуйста служебное наименование столбца с типом "),
                          _createElementVNode("b", null, "«Значение каталога;»", -1),
                          _createTextVNode(". Из параметров(min, max) записи, в ячейке из столбце-каталоге будут использованы для валидации значений ячеек текущего столбца. ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "readonly", "options"]))
            : _createCommentVNode("", true),
        _createVNode(_component_s_checkbox, {
          modelValue: _unref(innerValue).isSummary,
          "onUpdate:modelValue": [
            _cache[5] || (_cache[5] = ($event: any) => ((_unref(innerValue).isSummary) = $event)),
            proxyInput
          ],
          class: "s-form-input required base-margin-left",
          dense: "",
          required: "",
          "hide-bottom-space": "",
          disable: !availableToBeSummed.value || _ctx.readonly,
          label: "Сумма по строке"
        }, {
          default: _withCtx(() => [
            (!availableToBeSummed.value)
              ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createTextVNode(" Невозможно назначить столбец таблицы как сумму по строке, ")),
                    (_unref(innerValue).type === _unref(HandsontableCellType).text)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" значение ячейки не является числом ")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("не вычисляемых ячеек не осталось")
                        ], 64))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "disable"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(SBtn, {
        type: "icon",
        icon: "las la-trash-alt",
        disable: _ctx.readonly,
        tooltip: "Удаление столбца",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (!_ctx.readonly && _ctx.$emit('remove')))
      }, null, 8, ["disable"])
    ]),
    (_unref(innerValue).isSummary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row col-xs-12" }, "Столбцы доступные для суммирования", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_q_option_group, {
              modelValue: _unref(innerValue).summedColumns,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((_unref(innerValue).summedColumns) = $event)),
                proxyInput
              ],
              options: availableForSumColumns.value,
              disable: _ctx.readonly,
              color: "brand",
              type: "checkbox"
            }, {
              label: _withCtx(({ label, disable }) => [
                _createTextVNode(_toDisplayString(label) + " ", 1),
                disable
                  ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Столбец «" + _toDisplayString(label) + "» сам является суммой столбцов. ", 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "options", "disable"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})